var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('path',{attrs:{"fill-rule":"evenodd","fill":"#fff","d":"M3.1 13.98L0 14.2l.25-3.06 9.42-9.42 2.85 2.84-9.42 9.42z"}}),_c('path',{attrs:{"d":"M12.502.29l1.414 1.414a1 1 0 010 1.414l-1.131 1.131-2.828-2.828L11.088.289a1 1 0 011.414 0z","fill":"#fff"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }